import { Theme } from '@mui/material';
import { CSSObject } from '@mui/material/styles';
import { createContext, useContext } from 'react';

// The personalize button belongs in the panel header, but it needs the personalization
// context that only exists deep inside the conversation card — so it is portaled here.
const SidePanelToolsSlotContext = createContext<HTMLElement | null>(null);

export const SidePanelToolsSlotProvider = SidePanelToolsSlotContext.Provider;

export const useSidePanelToolsSlot = () => useContext(SidePanelToolsSlotContext);

export const floatingPanelToolSx = (theme: Theme): CSSObject => ({
  padding: 0,
  width: '2.125rem',
  height: '2.125rem',
  minWidth: '2.125rem',
  flexShrink: 0,
  borderRadius: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
  border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.22)',
  '&:hover': {
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: theme.palette.custom.OV.sys.onBackground,
  },
});
